import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useFAQDocumentDetails } from "@modules/ECMS/MAGP/Forms/FAQ/Faq.hook";
import { decodeHTML, encodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper, Loader } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { magpHost } from "~/Utils";
import { useGalleryList } from "../Gallery.hook";
import { fields } from "../constants";

export const AddNewGallery = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editGallery,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditGallery,
  } = useGalleryList(query.get("editId") || "");

  const {
    data: GalleryById,
    isLoading: isLoadingFaq,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditGallery();
    }
  }, [query.get("editId"), query.get("id")]);

  const faqFormConfig: FormConfig = {
    initialValues: {
      title: GalleryById
        ? decodeHTML(GalleryById.payload.title)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.title)
          : "",
      field_gallery_title_ms: GalleryById ? decodeHTML(GalleryById.payload.field_gallery_title_ms) : editGallery ? decodeHTML(editGallery?.[0]?.field_gallery_title_ms) : "",
      field_gallery_title_zh: GalleryById
        ? decodeHTML(GalleryById.payload.field_gallery_title_zh)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_gallery_title_zh)
          : "",
          field_src_type: GalleryById
        ? decodeHTML(GalleryById.payload.field_src_type)
        : editGallery
          ? decodeHTML(editGallery?.[0]?.field_src_type)
          : "",
      field_src_url:
          GalleryById?.payload && !isLoadingFaq
            ? decodeHTML([
                {
                  uid: "-1",
                  name: "field_src_url.png",
                  status: "done",
                  url: GalleryById?.payload?.field_src_url,
                },
              ])
            : decodeHTML([
                {
                  uid: "-1",
                  name: "field_src_url.png",
                  status: "done",
                  url: editGallery?.[0]?.field_src_url,
                },
              ]),
      field_gallery_published: GalleryById ? decodeHTML(GalleryById?.payload?.field_gallery_published) : decodeHTML(editGallery?.[0]?.field_gallery_published)

    },
    fields: fields.gallery,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    // for (let key in data) {
    //   if (typeof data[key] === "string" && !excludedKeys.includes(key)) {
    //     data[key] = encodeHTML(data[key]);
    //   }
    // }
    let imageKeys: any = [
      "field_src_url",
    ];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "MAGP");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    let publishKey: any=[
      'field_gallery_published'
    ]
    for (const key of publishKey) {
      data[key] = !!data[key];
    } 

    const payload = {
      action: action,
      method: method,
      module: "Gallery",
      subModule: "gallery",
      type: "DEDICATED",
      application: "MAGP",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAGP",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...data,
        published: true 
      },
      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response:any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response:any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === 'OK' && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else{
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Gallery`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingFaq || drilldownLoading}
        config={faqFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            query.get("editId") || query.get("type") === 'update'
              ? `${magpHost}/api/gallery-page-api${(editGallery?.[0]?.id || GalleryById?.payload?.id) ? `/${editGallery?.[0]?.id || GalleryById?.payload?.id}` : ""}`
              : `${magpHost}/api/create/gallery-page-api`,
            query.get("editId") || query.get("type") === 'update' ? "UPDATE" : "CREATE",
            query.get("editId") || query.get("type") === 'update' ? "PATCH" : "POST",
            buttonValue === "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }        
      />
    </ContentWrapper>
  );
};
